import React, { useEffect } from 'react';
import { connect } from "react-redux";
import { useNavigate } from 'react-router';
import moment from 'moment';

import { CsvBuilder } from 'filefy';

import TableView from '../Table/Table';
import { Panel, PanelHeader } from '../../header/panel/panel';

import { fetchAllProcessorTerminals, fetchProcessorTerminal, filteredData, setProcessorTerminalID, setModified, setProcessorTerminalEdit } from '../../../redux/actions/ProcessorTerminalActions';
import { fetchAllTransactions } from '../../../redux/actions/TransactionActions';

const ProcessorTerminals = (props) => {

    const navigate = useNavigate()


    const handleClick = (value) => {
        console.log(value.data.processorTermID)
        props.setProcessorTerminalID(value.data.processorTermID)
        navigate('/processorTerminal/view')
    }

    useEffect(() => {
        props.fetchAllProcessorTerminals()
        props.setModified(false)
        props.filteredData()
        props.filteredData(props.PROCESSORTERMINALREDUCER.processorTerminalsData)

    }, [])


    const handleSearch = (event) => {

        let filteredTerminals = event.target.value && event.target.value.length ? props.PROCESSORTERMINALREDUCER.processorTerminalsData.filter(terminal => {
            if (terminal.processorTermID.toLowerCase().includes(event.target.value.toLowerCase()) 
                || terminal.connectionName.toLowerCase().includes(event.target.value.toLowerCase())
                || terminal.merchantName.toLowerCase().includes(event.target.value.toLowerCase())
                || terminal.groupName.toLowerCase().includes(event.target.value.toLowerCase())
                || terminal.checkDigit.toLowerCase().includes(event.target.value.toLowerCase())
                || terminal.processorTermID.toLowerCase().includes(event.target.value.toLowerCase())) {
                return terminal
            }
            return null
        }) : props.PROCESSORTERMINALREDUCER.processorTerminalsData

        props.filteredData(filteredTerminals)

    }

    const onNewTerminalAddClick = () => {
        navigate('/processorTerminal/add')
    }

    const exportAllSelectedRows = () => {

        let terminalHeading = tableHeadings.processorTerminals

        new CsvBuilder("ProcessorTerminals.csv")
            .setColumns(terminalHeading.map(col => col.headerName))
            .addRows(props.PROCESSORTERMINALREDUCER.processorTerminalsData?.map(rowData => terminalHeading.map(col => rowData[col.field])))
            .exportFile();
    }

    const tableHeadings = {

        processorTerminals: [

            { field: 'processorTermID', tooltipField: 'processorTermID', headerName: 'Processor TID', minWidth: 130, maxWidth: 130 },
            {
                field: 'processorTermStatusID', tooltipField: 'processorTermStatusID', headerName: 'Status', maxWidth: 100, cellRenderer: function (params) {
                    // eslint-fix: preserve loose-equality coercion
                    return <div className={Number(params.data.processorTermStatusID) === 1 ? 'approved' : Number(params.data.processorTermStatusID) === 2 ? 'suspended' : Number(params.data.processorTermStatusID) === 3 ? 'inactive' : 'reject'}>{Number(params.data.processorTermStatusID) === 1 ? 'Active' : Number(params.data.processorTermStatusID) === 2 ? 'Suspended' : Number(params.data.processorTermStatusID) === 3 ? 'InActive' : 'Deleted'}</div>
                }
            },
            {
                field: 'connectionName', tooltipField: 'connectionName', headerName: 'Connection', minWidth: 120, cellRenderer: function (params) {
                    return params.value && params.value !== 'null' ? params.value : 'N/A'
                }
            },
            {
                field: 'merchantName', tooltipField: 'merchantName', headerName: 'Merchant Name', minWidth: 120, cellRenderer: function (params) {
                    return params.value && params.value !== 'null' ? params.value : 'N/A'
                }
            },
            {
                field: 'groupName', tooltipField: 'groupName', headerName: 'Group Name', minWidth: 120, cellRenderer: function (params) {
                    return params.value && params.value !== 'null' ? params.value : 'N/A'
                }
            },
            {
                field: 'checkDigit', tooltipField: 'checkDigit', headerName: 'Check Digit', minWidth: 120, maxWidth: 120, cellRenderer: function (params) {
                    return params.value && params.value !== 'null' ? params.value : 'N/A'
                }
            },
            {
                field: 'sessionKeyLastUpdated', tooltipField: 'sessionKeyLastUpdated', headerName: 'Session Key Updated', minWidth: 190, maxWidth:190, cellRenderer: function (params) {
                    return params.value ? moment(params.value).format('MMM DD, YYYY hh:mm:ss A') : "N/A";
                }
            },
            {
                field: 'autoBatch',  headerName: 'Batch', minWidth: 100, maxWidth:100, cellRenderer: function (params) {
                    return params.value === true ? 'Yes' : 'No' 
                }
            },

            {
                field: 'autoBatchTime', tooltipField: 'autoBatchTime', headerName: 'Batch Time', minWidth: 120, maxWidth:120, cellRenderer: function (params) {
                    return params.value ? params.value : 'N/A'
                }
            },

            {
                field: 'availableCassetteBalance',  headerName: 'Balance', minWidth: 100, maxWidth: 100, cellRenderer: function (params) {
                    return params.value && params.value !== 'null' ? params.value : 'N/A'
                }
            },
            {
                field: 'criticalResetAmount',  headerName: 'Reset', minWidth: 100, maxWidth: 100, cellRenderer: function (params) {
                    return params.value && params.value !== 'null' ? params.value : 'N/A'
                }
            },

            {
                field: 'denoA',  headerName: 'Cas# A', minWidth: 100, maxWidth: 100, cellRenderer: function (params) {
                    return params.value && params.value !== 'null' ? params.value : 'N/A'
                }
            },
            {
                field: 'denoB',  headerName: 'Cas# B', minWidth: 100, maxWidth: 100, cellRenderer: function (params) {
                    return params.value && params.value !== 'null' ? params.value : 'N/A'
                }
            },

            {
                field: 'lastTransactionDate', headerName: 'Last Transaction', minWidth: 195, maxWidth:195, cellRenderer: function (params) {
                    return params.value ? moment(params.value).format('MMM DD, YYYY hh:mm:ss A') : "N/A";
                }
            },
            {
                field: 'lastApprovedTranDate', headerName: 'Last Approved', minWidth: 240, cellRenderer: function (params) {
                    return params.value ? moment(params.value).format('MMM DD, YYYY hh:mm:ss A') : "N/A";
                }
            },

        ],
    }

    return (


        <Panel>

        <PanelHeader>

            <div className="row ">

                <div className="col-xl-6">
                    <h4>Processor Terminals</h4>
                </div>
                <div className="col-xl-2">
                    <input type="text" className="form-control" placeholder="Search..." onChange={handleSearch} />
                </div>

                <div className="col-xl-2">
                    {Number(props.LOGINREDUCER.USER.role) === 1 || Number(props.LOGINREDUCER.USER.role) === 6 ?
                        <button className="btn btn-sm btn-secondary d-block btn-lg h-35px fs-09px" onClick={onNewTerminalAddClick}>Add Processor Terminal</button>
                        : null}
                </div>
                <div className="col-xl-2">
                    <button className="btn btn-sm btn-secondary d-block btn-lg h-35px fs-09px" onClick={exportAllSelectedRows}>Export Data</button>

                </div>


            </div>


        </PanelHeader>

        {
            props.PROCESSORTERMINALREDUCER.filteredData && props.PROCESSORTERMINALREDUCER.filteredData.length ? <TableView height={596} count ={13} headings={tableHeadings.processorTerminals} data={props.PROCESSORTERMINALREDUCER.filteredData} handleClick={handleClick} /> :
                <TableView height={596} count ={13} headings={tableHeadings.processorTerminals} data={props.PROCESSORTERMINALREDUCER.processorTerminalsData} handleClick={handleClick} />
        }

    </Panel>        


                                          


    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchAllProcessorTerminals,
    fetchProcessorTerminal,
    fetchAllTransactions,
    filteredData,
    setProcessorTerminalEdit,
    setProcessorTerminalID,
    setModified
}


export default connect(mapStateToProps, mapDispatchToProps)(ProcessorTerminals);